import dayjs from 'dayjs';

import { isDayOff } from './helpers';
import { BusinessMonthRangeOutput, Day, DayObj, DayStatuses, Month } from './types';
import { api } from '../../index';
import { JointDay } from 'components/BusinessCalendar/components/BusinessCalendar/helpers/types';
import { convertArrayObjectKeysToLanguageCase } from 'helpers/utils/convertObject';

const resourceUrlUsers = '/calendar';

export const getCalendarByYear = (year: number) => api.get<Month[]>(`${resourceUrlUsers}/${year}/`);

export const getCalendarByMonth = (year: number, month: number) => api.get<Month>(`${resourceUrlUsers}/${year}/${month}/`);

/** Returns date of month start day and date of month end day */
export const getCalendarMonthRange = (userId: number, date: string) => {
  const year = dayjs(date).year();
  const month = dayjs(date).month() + 1;

  const errorObject = {
    404: {
      hidden: true,
    },
  };

  return api.get<BusinessMonthRangeOutput>(`/calendar/${year}/${month}/range/`, undefined, { errorObject });
};

/** Allows searching business month range by a day (date) */
export const getBusinessMonthByDate = (date: string) => {
  const errorObject = {
    404: {
      hidden: true,
    },
  };

  return api.get<BusinessMonthRangeOutput>('/calendar/months/range/', { day: date }, { errorObject });
};

export const updateBusinessCalendarPeriod = (days: DayObj[], businessMonthId: number) => api.put(`${resourceUrlUsers}/months/${businessMonthId}/`, {
  business_month_id: businessMonthId,
  days: convertArrayObjectKeysToLanguageCase(days, 'snakeCase'),
});

export const updateMonth = (days: Day[], monthId: number) => api.put(`${resourceUrlUsers}/months/${monthId}/`, {
  business_month_id: monthId,
  days: days.map((day: Day) => {
    const replacedStatus = isDayOff(day.day) ? DayStatuses.DayOff : DayStatuses.Holiday;

    return {
      day: day.day,
      status: day.status === DayStatuses.SuggestedHoliday ? replacedStatus : day.status,
      business_day_id: day.businessDayId,
    };
  }),
});
